import InitiativeDetail from '../../components/light/initiative/InitiativeDetail';

const initiative = {
  title: 'Foundational Learning & Academic Support Initiative (FLASI)',
  category: 'Education',
  year: '2020',
  location: 'Lagos, Ogun & Rivers States',
  heroImage: '/light/assets/imgs/spob/initiative-3.jpg',
  need: {
    headline:
      'Poor foundational literacy and numeracy skills among primary school pupils create a cycle of underachievement that is hard to break.',
    body: 'Overcrowded public primary school classrooms, limited teaching materials, and high pupil-to-teacher ratios leave many children without the individual attention they need to master reading and basic maths. By the time these gaps are noticed, pupils are already years behind, disengaged, and at risk of dropping out. FLASI was designed to intervene early and rebuild confidence in learning.',
  },
  approach: {
    headline:
      'Volunteer tutors run after-school sessions that focus on literacy, numeracy, and confidence-building.',
    body: "FLASI recruits and trains volunteer tutors — including university students and retired teachers — to hold structured after-school sessions twice a week in partner primary schools. Each session uses SPOB's simplified curriculum guide alongside donated textbooks and workbooks. Progress is tracked termly, and tutors receive ongoing coaching to maintain quality. Parent engagement workshops are also held to reinforce learning at home.",
  },
  stats: [
    { number: '3,000+', label: 'Pupils Supported' },
    { number: '150', label: 'Volunteer Tutors' },
    { number: '25', label: 'Schools Enrolled' },
  ],
  next: {
    title: 'Yoruba Heritage & Language Cultural Literacy',
    href: '/light/initiative-yoruba',
  },
};

export default function InitiativeFLASI() {
  return <InitiativeDetail initiative={initiative} />;
}
